import { useQuery } from '@tanstack/react-query';
import { GenQrBidvVAEntity, BidvVirtualAccountService } from 'services/openapi';

import { BidvVirtualAccountServiceQueryKeys } from '../constants';

type GetQrBidvVAQueryDTO = {
  vaPrefix: string;
  endCode: string;
  enabled?: boolean;
};

export const useGetQrBidvVAQuery = (variables: GetQrBidvVAQueryDTO) => {
  const { enabled = true, endCode, vaPrefix } = variables;
  const queryKey = [
    BidvVirtualAccountServiceQueryKeys.GET_QR,
    vaPrefix,
    endCode,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GenQrBidvVAEntity, Error>({
    queryKey,
    queryFn: () =>
      BidvVirtualAccountService.bidvVaControllerGetQr(vaPrefix, endCode),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled: enabled && !!vaPrefix && !!endCode,
  });

  return {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  };
};
